import React from "react";
import { mobile } from "../../utilities/detection";

import horizontalwebp1024 from "../../../assets/img/defaultScreenshotHorizontal_1024.webp";
import horizontaljpeg1024 from "../../../assets/img/defaultScreenshotHorizontal_1024.jpg";
import horizontalwebp890 from "../../../assets/img/defaultScreenshotHorizontal_890.webp";
import horizontaljpeg890 from "../../../assets/img/defaultScreenshotHorizontal_890.jpg";
import horizontalwebp768 from "../../../assets/img/defaultScreenshotHorizontal_768.webp";
import horizontaljpeg768 from "../../../assets/img/defaultScreenshotHorizontal_768.jpg";
import horizontalwebp640 from "../../../assets/img/defaultScreenshotHorizontal_640.webp";
import horizontaljpeg640 from "../../../assets/img/defaultScreenshotHorizontal_640.jpg";
import horizontalwebp366 from "../../../assets/img/defaultScreenshotHorizontal_366.webp";
import horizontaljpeg366 from "../../../assets/img/defaultScreenshotHorizontal_366.jpg";

import verticalwebp768 from "../../../assets/img/defaultScreenshotVertical_768.webp";
import verticaljpeg768 from "../../../assets/img/defaultScreenshotVertical_768.jpg";
import verticalwebp576 from "../../../assets/img/defaultScreenshotVertical_576.webp";
import verticaljpeg576 from "../../../assets/img/defaultScreenshotVertical_576.jpg";
import verticalwebp500 from "../../../assets/img/defaultScreenshotVertical_500.webp";
import verticaljpeg500 from "../../../assets/img/defaultScreenshotVertical_500.jpg";
import verticalwebp425 from "../../../assets/img/defaultScreenshotVertical_425.webp";
import verticaljpeg425 from "../../../assets/img/defaultScreenshotVertical_425.jpg";
import verticalwebp366 from "../../../assets/img/defaultScreenshotVertical_366.webp";
import verticaljpeg366 from "../../../assets/img/defaultScreenshotVertical_366.jpg";

export default function DefaultScreenshots({ game }) {
  if (game.id) {
    const orientation =
      (mobile && game.mobileOrientation && game.mobileOrientation === "portrait") || game.orientation === "portrait"
        ? "vertical"
        : "horizontal";

    const orientationData = {
      vertical: [
        {
          width: 400,
          src: {
            webp: [verticalwebp366, verticalwebp768],
            jpeg: [verticaljpeg366, verticaljpeg768],
          },
        },
        {
          width: 1439,
          src: {
            webp: [verticalwebp425, verticalwebp768],
            jpeg: [verticaljpeg425, verticaljpeg768],
          },
        },
        {
          width: 1919,
          src: {
            webp: [verticalwebp500, verticalwebp768],
            jpeg: [verticaljpeg500, verticaljpeg768],
          },
        },
        {
          src: {
            webp: [verticalwebp576, verticalwebp768],
            jpeg: [verticaljpeg576, verticaljpeg768],
          },
        },
      ],
      horizontal: [
        {
          width: 400,
          src: {
            webp: [horizontalwebp366, horizontalwebp768],
            jpeg: [horizontaljpeg366, horizontaljpeg768],
          },
        },
        {
          width: 639,
          src: {
            webp: [horizontalwebp640, horizontalwebp1024],
            jpeg: [horizontaljpeg640, horizontaljpeg1024],
          },
        },
        {
          width: 1439,
          src: {
            webp: [horizontalwebp768, horizontalwebp1024],
            jpeg: [horizontaljpeg768, horizontaljpeg1024],
          },
        },
        {
          width: 1919,
          src: {
            webp: [horizontalwebp890, horizontalwebp1024],
            jpeg: [horizontaljpeg890, horizontaljpeg1024],
          },
        },
        {
          src: {
            webp: [horizontalwebp1024, horizontalwebp1024],
            jpeg: [horizontaljpeg1024, horizontaljpeg1024],
          },
        },
      ],
    };

    let imgSrc = horizontaljpeg366;
    let imgWidth = 1024;
    let imgHeight = 768;

    if (orientation === "vertical") {
      imgSrc = verticaljpeg366;
      imgWidth = 576;
      imgHeight = 768;
    }

    const renderSources = () => {
      const orientationArray = orientationData[orientation];
      const sourcesArray = [];

      orientationArray.every((dataObject, orientationIndex) => {
        const { src, width } = dataObject;
        const hasMedia = !mobile && orientationIndex !== orientationArray.length - 1;

        const typeArray = ["webp", "jpeg"].map((typeString, typeIndex) => {
          const sourceKey = `sourceKey${orientationIndex}_${typeIndex}`;
          const srcArray = src[typeString];
          return (
            <source
              key={sourceKey}
              type={`image/${typeString}`}
              srcSet={`${srcArray[0]} 1x, ${srcArray[1]} 2x`}
              {...(hasMedia && { media: `(max-width: ${width}px)` })}
            />
          );
        });

        sourcesArray.push(...typeArray);

        if (mobile) return false;

        return true;
      });

      return sourcesArray;
    };

    return (
      <picture>
        {renderSources()}

        <img
          src={imgSrc}
          alt={game.fullname}
          width={imgWidth}
          height={imgHeight}
          draggable="false"
          fetchPriority="high"
        />
      </picture>
    );
  }

  return null;
}
